import React from 'react';
import Input from '..';

const TextArea = React.memo(props => <Input component="textArea" {...props} type="textArea" capsLock={false} />);

export default TextArea;
